import HolidayIcon from '@material-ui/icons/Event'; // Change the icon to something related to holidays
import AppointmentSettingList from './AppointmentSettingList';
import CreateAppointmentSetting from "./CreateAppointmentSetting";
import EditAppointmentSetting from "./EditAppointmentSetting";
export default {
    list: AppointmentSettingList,
    create: CreateAppointmentSetting,
    edit: EditAppointmentSetting,
    icon: HolidayIcon,
};
